import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkDischargeAccountsEntitlements,
    getDischargeAccountsEntitlementsProgress,
    stopBulkActions,
} from 'src/openapi/admin/apis/BulkDischargeAccountsEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {UpdateAccountsEntitlementsModal} from '../update-accounts-entitlements.modal';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {
    selectDischargeAccountsEntitlementsBulkUuid,
    selectDischargeAccountsEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './discharge-accounts-entitlements.slice';

import type {UpdateEntitiesEntitlementsRelation} from 'src/openapi/admin/models/UpdateEntitiesEntitlementsRelation';

type Props = {
    ids: string[],
    shown: boolean,
    onClose: () => void,
};

export const DischargeAccountsEntitlementsTool = ({ids, shown, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateEntitiesEntitlementsRelation>
            shown={shown}
            onClose={onClose}
            width={800}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectDischargeAccountsEntitlementsTask}
            uuidSelector={selectDischargeAccountsEntitlementsBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateEntitiesEntitlementsRelation, options) => (
                apiDispatch(bulkDischargeAccountsEntitlements({...options, updateEntitiesEntitlementsRelation}))
            )}
            getProgress={id => apiDispatch(getDischargeAccountsEntitlementsProgress({id}))}
            stopAction={id => apiDispatch(stopBulkActions({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={() => undefined}>
            {({processAction, onCloseModal}) => (
                <UpdateAccountsEntitlementsModal
                    ids={ids}
                    mode="DISCHARGE"
                    onCloseModal={onCloseModal}
                    processAction={processAction}
                />
            )}
        </BulkActionTool>
    );
};
